import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { MealTiersMiniEntity } from '@/features/mealTiers/domain/entities/MealTiersMiniEntity'

export class CompanyUsersEntity {
  id?: number;
  companyId?: number;
  companyName?: string | null;
  userId?: string;
  userDisplayName?: string | null;
  mealTierId?: number;
  mealTierName?: string | null;
  maxItemPerMeal?: number | null;
  user?: UserMiniEntity;
  mealTier?: MealTiersMiniEntity;
}
  